import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RegisterAdvisor from "../components/IndexPage/RegisterAdvisor";

const AdviserHome = () => {
  useEffect(() => {
    $("#login_modal").modal("hide");
    $(".showActive").addClass("hide");
    const queryParams = new URLSearchParams(window.location.search);
    const type = queryParams.get("type");
    if(type==null){
      $("#login_modal").modal("hide");
      $(".showActive").addClass("hide");
    }else{
      if(type=='Activate'){
        $("#login_modal").modal("show");
        $(".showActive").removeClass("hide");
      }else{
        $("#login_modal").modal("show");
      }
      
    }
  });
  return (
    <>
      <main>
        <section className="advisor-banner">
          <div className="container">
            <div className="row banner-content align-items-center text-center">
              <div className="col-lg-10 offset-lg-1">
                <div className="content">
                  <h1>
                    Connect with borrowers actively looking for a mortgage
                  </h1>
                  <p>
                    Join a buzzing ecosystem and find high quality customers
                    today
                  </p>
                  <Link
                    to={`/register`}
                    className="btn-white btn-expert text-uppercase page-scroll margin-right-15"
                  >
                    Sign Up
                  </Link>
                  <Link
                    to={`/pricing`}
                    className="btn-white btn-expert text-uppercase page-scroll"
                  >
                    Pricing
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="help-you-section business-section">
          <img
            src="assets/images/business_right.png"
            alt="help-1"
            className="img-fluid before-img"
          />
          <img
            src="assets/images/business_left.png"
            alt="help-1"
            className="img-fluid after-img"
          />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12 text-center">
                <div className="heading">
                  <h2 className="text-uppercase">
                    Easily build your business with Mortgagebox
                  </h2>
                  <span></span>
                  <p>
                    See all leads as they are listed. Review the ones that look
                    interesting and then decide if you want to be introduced.
                    There are no fixed costs and you only pay a small fee for
                    the leads you want. A maximum of five mortgage advisers are
                    connected.
                  </p>
                </div>
              </div>
            </div>
            <div className="row help-boxes">
              <div className="col-xl-4 col-lg-6">
                <div className="help-box text-center">
                  <div className="box-img text-center">
                    <img
                      src="assets/images/business-2.png"
                      alt="help-2"
                      className="img-fluid"
                    />
                  </div>
                  <h6 className="text-center">Start receiving leads quickly</h6>
                  <span></span>
                  <ul className="ml-0 mb-0 text-left">
                    <li>
                      Instant access to UK consumers actively looking for
                      mortgages.
                    </li>
                    <li>Its free to sign up and explore the platform.</li>
                    <li>
                      Create a professional profile, define preferences and
                      upload reviews.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="help-box text-center">
                  <div className="box-img text-center">
                    <img
                      src="assets/images/business-1.png"
                      alt="help-1"
                      className="img-fluid"
                    />
                  </div>
                  <h6 className="text-center">Focus on the right people</h6>
                  <span></span>
                  <ul className="ml-0 mb-0 text-left">
                    <li>
                      High quality leads matched to your preferences and
                      specialisms.
                    </li>
                    <li>
                      Review the customers profile and mortgage need before
                      deciding.
                    </li>
                    <li>Choose the leads you want.</li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="help-box text-center">
                  <div className="box-img text-center">
                    <img
                      src="assets/images/business-3.png"
                      alt="help-3"
                      className="img-fluid"
                    />
                  </div>
                  <h6 className="text-center">Great value and simple to use</h6>
                  <span></span>
                  <ul className="ml-0 mb-0 text-left">
                    <li>
                      Try it for free with five free introductions, we're
                      confident you'll like it.
                    </li>
                    <li>Pay only for the leads you want.</li>
                    <li>
                      Apart from that there are no fixed costs and no hidden
                      fees.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-12 text-center register-btn">
                <a
                  href={`/adviser`}
                  className="btn-bg-blue text-uppercase page-scroll"
                >
                  Sign Up
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="we-belive-section how-works-section mt-0">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <div className="belive-content">
                  <div className="heading">
                    <h2>HOW MORTGAGEBOX WORKS</h2>
                    <span></span>
                  </div>
                  <div className="row work-boxes">
                    <div className="col-lg-3 col-md-6">
                      <div className="box text-center">
                        <div className="box-img">
                          <img
                            src="assets/images/work-1.png"
                            alt="work-1"
                            className="img-fluid"
                          />
                          <span>1</span>
                        </div>
                        <h6 className="text-center text-uppercase">
                          Mortgage need
                        </h6>
                        <p>
                          Customers raise a mortgage need, outlining key details
                          and profile.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="box text-center">
                        <div className="box-img">
                          <img
                            src="assets/images/03-2.png"
                            alt="work-2"
                            className="img-fluid"
                          />
                          <span>2</span>
                        </div>
                        <h6 className="text-center text-uppercase">
                          Personalised matching
                        </h6>
                        <p>
                          A personalised set of leads is created by matching
                          your skills & preferences to customer needs.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="box text-center">
                        <div className="box-img">
                          <img
                            src="assets/images/work-3.png"
                            alt="work-3"
                            className="img-fluid"
                          />
                          <span>3</span>
                        </div>
                        <h6 className="text-center text-uppercase">
                          Choose your leads
                        </h6>
                        <p>
                          You choose and only pay for the leads you want. A
                          maximum of five advisers are introduced.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="box text-center">
                        <div className="box-img">
                          <img
                            src="assets/images/work-4.png"
                            alt="work-4"
                            className="img-fluid"
                          />
                          <span>4</span>
                        </div>
                        <h6 className="text-center text-uppercase">
                          Connect & engage
                        </h6>
                        <p>
                          Chat, message, speak to the customer. Tell them what
                          makes you their perfect adviser.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="expert-advise-section">
          <img
            src="assets/images/expert-right.png"
            alt="help-1"
            className="img-fluid after-img"
          />
          <div className="container">
            <div className="row">
              <div className="col-lg-7 text-left">
                <div className="heading">
                  <h2 className="text-uppercase">
                    What do we expect from mortgage advisers?
                  </h2>
                  <span></span>
                  <div className="left-content">
                    <p>
                      We want our customers to receive the best service at the
                      lowest possible cost. In return for providing high quality
                      leads we have the following expectations
                    </p>
                    <ul className="ml-0">
                      <li>Must be FCA registered.</li>
                      <li>
                        Does not charge fees for standard mortgages. If fees are
                        unavoidable, for example extra work needed to arrange a
                        specialised mortgage, then this must be clearly
                        communicated at the start of the process.
                      </li>
                      <li>
                        Offers the customers a warm welcome and a free no
                        obligation chat to identify available solutions and the
                        one best suited to their needs.
                      </li>
                      <li>
                        Takes away the stress and hassle by guiding the customer
                        through the whole process, from searching for deals to
                        organizing the legal aspects.
                      </li>
                      <li>Uphold the mortgagebox ethos.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 text-center">
                <div className="row">
                  <div className="col-6">
                    <img
                      src="assets/images/business-4.png"
                      alt="business-4"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="col-6">
                    <img
                      src="assets/images/business-5.png"
                      alt="business-5"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="col-12 mt-4">
                    <img
                      src="assets/images/business-6.png"
                      alt="business-6"
                      className="img-fluid w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="col-12 text-center register-btn">
          <a
            href={`/adviser`}
            className="btn-bg-blue text-uppercase page-scroll"
          >
            Sign Up
          </a>
        </div>
        {/* <RegisterAdvisor /> */}
      </main>
    </>
  );
};
export default AdviserHome;
